import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

const fetchSystemWalletsUserCanElevateTo = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token, true); // disable elevation for this endpoint.
    return axiosInstance().get(url, withHeaders(headers));
};

export const useElevateSystemWallets = (): UseQueryResult<
    AxiosResponse<any, any>,
    unknown
> => {
    const { getToken } = useAuth();

    const url = `/metadata/system/wallet/self`;
    return useQuery(`elevate-system-wallets`, async () =>
        fetchSystemWalletsUserCanElevateTo(url, getToken())
    );
};
